import { FieldValueType } from '../../../../types';
import { getCellDataValue } from './utils';

type MappingReportValuePropsType = {
    fieldValue: FieldValueType;
};
function MappingReportValue({ fieldValue }: MappingReportValuePropsType) {
    return (
        <div className="flex">
            <span className="ml-auto">{getCellDataValue(fieldValue.rawValue)}</span>
        </div>
    );
}

export default MappingReportValue;
